import React, { useEffect, useState } from 'react'
import { FaArrowCircleLeft } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { fetchData } from '../../helpers/fetchData'
import SkeletonCardLoading from '../../shared/SkeltonCardLoading'
import PatientVisitDetails from '../../components/his/visits/PatientVisitDetails'
import ViewItems from '../../components/his/visits/ViewItems'
import NoDataFound from '../../shared/NoDataFound'

function PatientActiveOrders () {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { t } = useTranslation()
  const patientData = state?.patientData || null

  const [isLoading, setIsLoading] = useState(false)
  const [patientVisits, setPatientVisits] = useState([])

  const isUnpaidItem = item => {
    const hasInvoice =
      item?.cash_invoice_number ||
      item?.pharmacy_invoice_number ||
      item?.insurance_invoice_number ||
      item?.government_invoice_number ||
      item?.corporate_invoice_number ||
      item?.invoice_numbers?.cash_invoice_number ||
      item?.invoice_numbers?.pharmacy_invoice_number ||
      item?.invoice_numbers?.insurance_invoice_number ||
      item?.invoice_numbers?.government_invoice_number ||
      item?.invoice_numbers?.corporate_invoice_number

    return item?.status?.toLowerCase() !== 'paid' && !hasInvoice
  }

  const visitsWithUnpaidItems = patientVisits
    ?.map(visitData => ({
      ...visitData,
      items: (visitData?.items || []).filter(isUnpaidItem)
    }))

  useEffect(() => {
    const getVisitsList = async () => {
      if (!patientData?.patient_id) return

      setIsLoading(true)
      try {
        const res = await fetchData('POST', '/v3/visit/getPatientVisitByIdV3', {
          patient_id: patientData.patient_id,
          status: 'All'
        })
        setPatientVisits(res?.visits || [])
      } catch (error) {
        console.error(error)
        setPatientVisits([])
      } finally {
        setIsLoading(false)
      }
    }

    getVisitsList()
  }, [patientData?.patient_id])

  return (
    <div className='main-page-container !overflow-y-auto scrollbar !py-4 !bg-gray-50'>
      <div className='w-full'>
        <div className='mb-4 flex items-center gap-2'>
          <FaArrowCircleLeft
            className='cursor-pointer text-primary'
            size={20}
            onClick={() => navigate(-1)}
          />
          <h3 className='text-darkBg text-[16px] md:text-[18px] lg:text-[20px] font-[600]'>
            {patientData?.full_name
              ? `${patientData.full_name} - ${t('Patient Active Orders')}`
              : t('Patient Active Orders')}
          </h3>
        </div>

        <div>
          {isLoading ? (
            <div className='grid grid-cols-1 w-full gap-y-2'>
              {[...Array(6)].map((_, index) => (
                <SkeletonCardLoading
                  key={index}
                  count={4}
                  parentClassName='w-full  bg-transparent border border-gray-200 rounded-md py-4'
                />
              ))}
            </div>
          ) : patientVisits?.length > 0 ? (
            <div className='flex flex-col gap-4'>
              {visitsWithUnpaidItems.map(visitData => (
                <div
                  key={visitData.visit_id}
                  className='overflow-hidden rounded-md border border-gray-200 bg-white'
                >
                  <PatientVisitDetails
                    visitData={visitData}
                    isWithOutSlot
                    setPatientVisit={setPatientVisits}
                    setIsLoading={setIsLoading}
                    lowBod={true}
                  />
                  <ViewItems
                    visitData={visitData}
                    embedded
                    disableDateGrouping
                    hideEmptyState
                  />
                </div>
              ))}
            </div>
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>
    </div>
  )
}

export default PatientActiveOrders
